/* eslint-disable */

import { IContext, IElement, IKenticoCustomElement } from 'types/kenticoSdk.interface';

export const isInIFrame = window.location !== window.parent.location;

export class KenticoSdk {
  public CustomElement: IKenticoCustomElement | undefined;
  public element: IElement | undefined;
  public context: IContext | undefined;
  private height = 1000;

  constructor() {
    if (isInIFrame) {
      this.loadKenticoSDK();
    }
  }

  /**
   * Inits kentico SDK if application is in iframe
   */

  private initKenticoSDK = (): void => {
    this.CustomElement = (window as any).CustomElement;
    this.initCustomElement();
  };

  /**
   * Loads kentico SDK and init SDK after script is loaded
   */

  private loadKenticoSDK = (): void => {
    const script = document.createElement('script');

    script.src = 'https://app.kontent.ai/js-api/custom-element/v1/custom-element.min.js';
    script.onload = () => {
      this.initKenticoSDK();
    };
    document.body.appendChild(script);
  };

  /**
   * Inits application as kentico custom element
   */

  private initCustomElement = (): void => {
    this.CustomElement?.init((element, context) => {
      const { config } = element;

      this.element = element;
      this.context = context;

      return config?.height
        ? this.CustomElement?.setHeight(Number(config.height))
        : this.CustomElement?.setHeight(this.height);
    });
  };
}

export const kenticoSdk = new KenticoSdk();
